<template>
  <Teleport to="#wrapper">
    <nav class='player' v-if='props.playlist && props.context?.files'>
      <SoundFile v-for='(item, index) in list' :key='item.title' :file='file(filename(item))' :item='item' :title='item.title' :context='context' :is-first='index === 0' />
    </nav>
  </Teleport>
</template>

<script setup>
import { yamlToObject } from '@/utils'
const props = defineProps(['playlist', 'context']);
const list = computed(() => yamlToObject(props.playlist));

const filename = (item) => {
  return item?.file?.[0] || '';
};

const file = (filename) => {
  if (!filename || !props?.context?.files) return null;
  return props.context.files.find(obj => obj['filename'] === filename) || null;
};
</script>

<style scoped>
  nav {
    /*border: 1px solid rgba(255,255,255,0.025);*/
    position: fixed;
    top: calc(var(--header-padding) - 1rem);
    left: 0;
    right: 0;
    max-width: clamp(340px, 27vw, 42rem);
    z-index: 999;
    margin: auto;
    border-radius: 10rem;
    backdrop-filter: blur(0.4rem);
    background-color: rgba(26, 26, 26, 1);
  }

  @media (max-width: 1080px) {
    nav {
      top: calc(100vh - 15.5rem);
    }
  }
</style>
